import type { IconType } from 'react-icons';
import { MdOutlineCalendarMonth } from 'react-icons/md';

import { NumberArrows } from '@/components/UnitInput/NumberArrows';

import s from './DayCountsSection.module.scss';
import { SectionHeader } from './SectionHeader';

type DayCountField = 'usageDays' | 'underwayDays' | 'ownerGuestMeals';

interface DayCountsSectionProps {
  usageDays: string;
  underwayDays: string;
  ownerGuestMeals: string;
  onChange: (field: DayCountField, val: string) => void;
  icon?: IconType;
}

const COUNTS: Array<{ key: DayCountField; label: string }> = [
  { key: 'usageDays', label: 'Usage Days' },
  { key: 'underwayDays', label: 'Underway Days' },
  { key: 'ownerGuestMeals', label: 'Owner Guest Meals' },
];

export function DayCountsSection({
  usageDays,
  underwayDays,
  ownerGuestMeals,
  onChange,
  icon: Icon = MdOutlineCalendarMonth,
}: DayCountsSectionProps) {
  const values: Record<DayCountField, string> = { usageDays, underwayDays, ownerGuestMeals };

  return (
    <div className={s.section}>
      <SectionHeader icon={Icon} title="Day Counts" />

      <div className={s.grid}>
        {COUNTS.map(({ key, label }) => (
          <div key={key} className={s.col}>
            <div className={s.field}>
              <input
                id={`day-count-${key}`}
                type="number"
                value={values[key] || '0'}
                onChange={(e) => onChange(key, e.target.value)}
                className={s.input}
                min="0"
              />
              <NumberArrows
                value={values[key]}
                onChange={(v) => onChange(key, v)}
                min={0}
                name={label}
              />
            </div>
            <label htmlFor={`day-count-${key}`} className={s.label}>
              {label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
